








import { createComponent, computed } from "@vue/composition-api";

interface BaseMoreInfo {
  value: boolean;
  showLessText: string;
  showMoreText: string;
}

export default createComponent({
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showMoreText: {
      type: String,
      required: true
    },
    showLessText: {
      type: String,
      required: true
    }
  },
  setup(props: Readonly<BaseMoreInfo>) {
    const textToShow = computed(() =>
      props.value ? props.showLessText : props.showMoreText
    );

    return {
      textToShow
    };
  }
});
